import script from "./AssignUsersDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AssignUsersDialog.vue?vue&type=script&setup=true&lang=js"

import "./AssignUsersDialog.vue?vue&type=style&index=0&id=adb10c26&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-adb10c26"]])

export default __exports__